/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { STORAGE_KEYS } from '@/constants/storageKeys'

import { CHECK, LOGIN, LOGOUT, REGISTER } from './mutation-types.js'

export default {
  [CHECK](state) {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
    state.isAuthenticated = !!token

    return state.isAuthenticated
  },

  [REGISTER](state, params) {
    state.registrationMethod = params.method
  },

  [LOGIN](state, token) {
    state.isAuthenticated = true
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
  },

  [LOGOUT](state) {
    state.isAuthenticated = false
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
  }
}
